var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelveDashboardOrderStatusUnverified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.854614,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDF8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.8546H28",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.8546H28",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 13.8546H33C33.2652 13.8546 33.5196 13.96 33.7071 14.1475C33.8946 14.335 34 14.5894 34 14.8546V35.8546C34 36.1198 33.8946 36.3742 33.7071 36.5617C33.5196 36.7493 33.2652 36.8546 33 36.8546H15C14.7348 36.8546 14.4804 36.7493 14.2929 36.5617C14.1054 36.3742 14 36.1198 14 35.8546V14.8546C14 14.5894 14.1054 14.335 14.2929 14.1475C14.4804 13.96 14.7348 13.8546 15 13.8546H19.9997",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.8546V16.8546C19 15.5285 19.5268 14.2568 20.4645 13.3191C21.4021 12.3814 22.6739 11.8546 24 11.8546C25.3261 11.8546 26.5979 12.3814 27.5355 13.3191C28.4732 14.2568 29 15.5285 29 16.8546V17.8546H19Z",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelveDashboardOrderStatusUnverified);
export default __webpack_public_path__ + "static/media/delve-dashboard-order-status-unverified.b0d53dc71a246ea99bc3d4e353d7e720521c03da074d85dff8384d1da876edcf.svg";
export { ForwardRef as ReactComponent };